<template>
  <textarea :rows="rows" v-model="localValue" v-on="listeners" v-bind="$attrs" class="c-base-textarea" :class="[{ 'c-base-textarea--is-valid': state === true, 'c-base-textarea--is-invalid': state === false }]" />
</template>

<script>
export default {
  name: 'BaseTextarea',

  model: {
    prop: 'value',
    event: 'update'
  },

  props: {
    value: {
      type: [String],
      default: ''
    },
    rows: {
      type: Number,
      default: 3
    },
    state: {
      type: [Boolean, null],
      default: null
    },
    lazy: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      localValue: this.value
    }
  },

  mounted () {
    this.$watch(() => this.value, value => {
      if (this.localValue !== value) {
        this.localValue = value
      }
    })
  },

  computed: {
    listeners () {
      const { input, change, blur, ...listeners } = this.$listeners
      return {
        input: event => this.onEvent(event, 'input'),
        change: event => this.onEvent(event, 'change', true),
        blur: event => this.onEvent(event, 'blur', true),
        ...listeners }
    }
  },

  methods: {
    onUpdate (value, force = false) {
      if (this.lazy && !force) {
        return
      }

      if (this.localValue !== value) {
        this.localValue = value
      }

      this.$emit('update', value)
    },

    onEvent (event, name, force = false) {
      this.onUpdate(event.target.value, force)
      this.$emit(name, event.target.value)
    }
  }
}
</script>
